import React from "react"
import HomeWrapper from "../../../containers/main/HomeWrapper"

export default () => <HomeWrapper />
